import axiosInstance from "../utils/axiosClient";

const getDataByPagination = async (route, paramsUrl) => {
  const buildParams = {};
  if (paramsUrl && paramsUrl.includes("?")) {
    const listParams = paramsUrl.split("?");
    listParams.shift(); // first element is the url base (not params)
    listParams.forEach((param) => {
      const paramKey = param.split("=")[0];
      const paramValue = param.split("=")[1];
      buildParams[paramKey] = paramValue;
    });
  }
  const response = await axiosInstance.get(route, {
    params: buildParams,
  });
  return response.data;
};

export const getTouristServers = async (url) => {
  return await getDataByPagination("tourist-servers/", url);
};

export const getTouristServersById = async (id) => {
  const response = await axiosInstance.get(`tourist-servers/${id}/`);
  return response.data;
};

export const getTouristAtractives = async (url) => {
  return await getDataByPagination("tourist-attraction/", url);
};

export const getTouristAtractivesById = async (id) => {
  const response = await axiosInstance.get(`tourist-attraction/${id}/`);
  return response.data;
};

export const getTouristRoutes = async () => {
  const response = await axiosInstance.get(`tourist-route/`);
  return response.data.results;
};

export const getTouristRouteById = async (id) => {
  const response = await axiosInstance.get(`tourist-route/${id}/`);
  return response.data;
};

export const getTransport = async () => {
  const response = await axiosInstance.get(`transport/`);
  return response.data.results;
};
